export default __webpack_public_path__ + "static/media/Character-05.93cc26a3.png";